<template>
  <div class="bootstrap search-container">
    <div class="row">
      <div class="col-md-8" :class="{ 'col-md-12' : !showPostIndex, 'col-md-8' : showPostIndex }">
        <div v-if="!currentPoint">
          <input type="text" v-model="name" class="form-control" @keyup="getGeoObjects"
                 placeholder="населенный пункт / город..."/>
        </div>
        <div v-else>
          <b>Населенный пункт/город: </b><br/> {{ currentPoint.name }} &nbsp; <a href="javascript:void(0)"
                                                                                 @click="currentPoint=null;name=null; currentPostIndex=null; postIndex=null;">изменить</a><br/>
        </div>
        <div class="search-result">
          <ul>
            <li v-for="point in geonames" :key="point.id">
              <a href="javascript:void(0)" @click="selectGeoObject(point)">{{ point.full_name || point.name }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-4" v-if="showPostIndex">
        <div class="select-post-index" v-if="!currentPostIndex">
          <input type="text" v-model="postIndex" class="form-control post-index-input" @blur="trackPostIndex"
                 placeholder="почтовый индекс..."/>
          <div class="search-result">
            <ul>
              <li v-for="postCode in filteredPostIndex" :key="postCode">
                <a href="javascript:void(0)" @click="selectPostIndex(postCode)"><b>{{ postCode }}</b></a>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <b>Почтовый индекс: </b> {{ currentPostIndex }} &nbsp; <a href="javascript:void(0)"
                                                                    @click="currentPostIndex=null; postIndex=null;">изменить</a><br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DELIVERY_SERVICE_SDEK,
  DELIVERY_SERVICE_BOXBERRY,
  DELIVERY_SERVICE_RUSSIAN_POST
} from "../constant"


export default {
  name: 'SelectAddress',
  props: ['showPostIndex', 'serviceId'],
  data() {
    return {
      postIndex: null,
      currentPostIndex: null,
      name: null,
      geonames: [],
      currentPoint: null
    }
  },
  methods: {
    getGeoObjects() {
      switch (this.serviceId) {
        case DELIVERY_SERVICE_SDEK:
          this.$http.get('/delivery-service/settelments/cdek/' + this.name).then(response => {
            this.$log(response.data);
            this.geonames = response.data
          }, function (error) {
            this.$log(error);
          });

          // this.$http.jsonp('https://api.cdek.ru/city/getListByTerm/jsonp.php?q=' + this.name + '&callback=foo').then((data) => {
          //   data.json().then((geonames) => {
          //     this.geonames = geonames.geonames
          //   })
          // }, function (error) {
          //   this.$log(error);
          // });
          break;
        case DELIVERY_SERVICE_BOXBERRY:
          this.$http.get('/delivery-service/settelments/boxberry/' + this.name).then(response => {
            this.$log(response.data);
            this.geonames = response.data
          }, function (error) {
            this.$log(error);
          });
          break;
        default:
          this.$log('Не указан или неизвестный тип сервиса ' + this.serviceId);
      }


    },
    selectGeoObject(point) {
      this.currentPoint = point;
      this.geonames = []
      this.$emit('select-address', {
        'post_code': this.currentPostIndex || null,
        'point': this.currentPoint || {"service_id": this.serviceId, "name" : this.name}
      })
    },
    selectPostIndex(postIndex) {
      this.currentPostIndex = postIndex
      this.$emit('select-address', {
        'post_code': postIndex,
        'point': this.currentPoint || { "service_id": this.serviceId, "name" : this.name }
      })
    },
    clear() {
      this.currentPoint = null;
      this.currentPostIndex = null;
      this.postIndex = null;
      this.name = null;
      this.$emit('select-address', {
        'post_code': null,
        'point': null
      })
    },
    trackPostIndex() {
      if ([DELIVERY_SERVICE_BOXBERRY, DELIVERY_SERVICE_SDEK, DELIVERY_SERVICE_RUSSIAN_POST].indexOf(this.serviceId) > -1 && this.postIndex.length == 6) {
        this.selectPostIndex(this.postIndex);
      }
    }
  },
  computed: {
    filteredPostIndex() {
      if (!this.currentPoint) return []
      if (!this.currentPoint.postCodeArray) return []
      return this.currentPoint.postCodeArray.filter(postCode => postCode.indexOf(this.postIndex) > -1)
    }
  }
}
</script>

<style lang="scss" scoped>
input.form-control {
  display: inline-block !important;
  font-size: 14px;
}

.search-container {
  line-height: 1.4;

  .search-result {
    z-index: 1000;
    width: 100%;

    ul {
      li {
        a {
          color: black !important;
        }
      }
    }
  }
}

.select-post-index {
  .search-result {
    width: 100%;

    ul {
      li {
        a {
          color: black !important;
        }
      }
    }

  }
}
</style>